/* global dataLayer */

/**
 * Tracking function avoiding to throw errors if any user plugin will block these kind of tracking javascript events
 * @param {object} data - data to track
 */
export default function track(data) {
    /*if (globals.config.debug && console.group && console.table) {
        console.group('Debug tracking event');
        console.table(data);
        console.groupEnd();
    }*/
    try {
        return dataLayer.push(data);
    } catch (error) {
        return error;
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/track.js